import { createFromIconfontCN } from '@ant-design/icons';
import React from 'react';
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_3519092_r55o1hmlf6.js',
});
export default IconFont;